import {
    DetailsWrapper,
    StyledContactCard,
} from "./ProjectsDashboardDetails.styles";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import BlockHead from "shared/components/layout/heads/BlockHead";
import ContactCard from "shared/components/data-display/drawers/ContactCard";
import HStack from "shared/components/layout/stack/HStack";
import Icon from "shared/components/utils/Icon";
import Modal from "shared/components/feedback/modals/MasterModal";
import ProjectDashboardDetailsDataLeadProducerForm from "features/projects/project-dashboard/single/ProjectDashboardDetailsDataLeadProducerForm";
import ProjectDashboardOverviewDataPISForm from "features/projects/project-dashboard/single/ProjectDashboardOverviewDataPISForm";
import ProjectsDashboardDetailsData from "features/projects/project-dashboard/single/ProjectsDashboardDetailsData";
import TertiaryButton from "shared/components/inputs/button/TertiaryButton";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import env from "react-dotenv";
import { isBefore } from "date-fns";
import { useProjectById } from "features/projects/project-dashboard/single/useProjectsDashboardData";
import { useProjectLeadAssignment } from "features/projects/project-dashboard/single/useProjectsDashboardDetailsData";
import useRetainersDashboardUserDetails from "features/projects/retainers-dashboard/single/useRetainersDashboardUserDetails";

const FormPresenter = () => {
    const { projectId } = useParams();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const action = searchParams.get("action");
    const id = searchParams.get("leadProducerId");
    const parsedId = Number.parseInt(id);

    const onClose = () => {
        navigate(".", { replace: true });
    };

    if (action === "addLeadProducer") {
        return (
            <Modal title="Select Lead Producer" onRequestClose={onClose}>
                <ProjectDashboardDetailsDataLeadProducerForm
                    projectIdToAddEditLead={projectId}
                    key={projectId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    if (action === "edit" && !Number.isNaN(parsedId)) {
        return (
            <Modal title="Select Lead Producer" onRequestClose={onClose}>
                <ProjectDashboardDetailsDataLeadProducerForm
                    projectIdToAddEditLead={projectId}
                    leadProducerId={parsedId}
                    key={parsedId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    if (action === "editPIS") {
        return (
            <Modal
                title="Personal Information Status"
                onRequestClose={onClose}
                stickyAction={true}
            >
                <ProjectDashboardOverviewDataPISForm
                    projectIdToEditPIS={projectId}
                    key={projectId}
                    onClose={onClose}
                />
            </Modal>
        );
    }

    return <></>;
};

const NoLeadProducerCardContent = () => {
    return (
        <VStack>
                <HStack>
                    <BlockHead title="Lead Producer" />

                    <TertiaryButton
                        to="?action=addLeadProducer"
                        replace={true}
                        aria-label="Add lead producer"
                        trailingIcon="edit"
                        iconWidth={16}
                        style={{
                            color: "currentColor",
                            background: "transparent",
                        }}
                    />
                </HStack>
                <VStack spacing="Zero_5">
                    <HStack spacing="Zero_25">
                        <Icon size={16} name="warning" color="Yellow" />
                        <Text color="Black" variant="Body_2_2">
                            No Lead Producer
                        </Text>
                    </HStack>
                </VStack>
        </VStack>
    );
};

const ProjectsDashboardDetails = () => {
    const { projectId } = useParams();
    const { project } = useProjectById();
    const { useLeadAssignment } = useProjectLeadAssignment();
    const leadProducer = useLeadAssignment(projectId);
    const [leadProducerId, setLeadProducerId] = useState();
    const { useUserById } = useRetainersDashboardUserDetails();
    const userDetails = useUserById(leadProducerId);
    const actionProps = {
        to: `?action=edit&leadProducerId=${leadProducerId}`,
        replace: true,
        "aria-label": "Edit Lead Producer",
    };

    useEffect(() => {
        if (!leadProducer.isLoading && leadProducer?.data?.length !== 0) {
            const mostRecentDate = leadProducer?.data?.reduce((a, b) =>
                a.StartDate > b.StartDate ? a : b
            ).StartDate;
            const recentDate = new Date(mostRecentDate);
            const recentObject = leadProducer?.data?.find((e) => {
                const date = new Date(e.StartDate);
                return date.getTime() === recentDate.getTime();
            });            
            
            const isInactive = recentObject?.EndDate ? isBefore(new Date(recentObject?.EndDate), new Date()) : false;
            isInactive ? setLeadProducerId(null) : setLeadProducerId(recentObject?.EmployeeId);
        }
    }, [leadProducer]);

    if (userDetails.isLoading || leadProducer.isLoading || project.isLoading) {
        return <>Loading...</>;
    }

    return (
        <>
            <FormPresenter />
            <DetailsWrapper>
                {leadProducerId ? (
                    <>
                        <StyledContactCard />
                        <ContactCard
                            contactCardLabel="Lead Producer"
                            contactCardLabelVariant="Body_2_1"
                            photoUrl={
                                env.BESTWORK_REACT_ASSET_DOMAIN +
                                "/" +
                                userDetails?.data?.photoURL
                            }
                            name={userDetails?.data?.fullName}
                            jobPost={userDetails?.data?.currentTitle}
                            department={userDetails?.data?.currentDepartment}
                            location={userDetails?.data?.currentOffice}
                            emailId={userDetails?.data?.email}
                            actionIcon="edit"
                            hasAction={true}
                            actionProps={actionProps}
                        />
                    </>
                ) : (
                    <NoLeadProducerCardContent />
                )}
                <ProjectsDashboardDetailsData project={project} />
            </DetailsWrapper>
        </>
    );
};

export default ProjectsDashboardDetails;
